import { BaseNumber } from '@sparkdotfi/common-universal'
import { QueryKey } from '@tanstack/react-query'
import { erc20Abi } from 'viem'
import { Config } from 'wagmi'
import { readContract } from 'wagmi/actions'

import { Token } from '@/domain/types/Token'

export interface SavingsV2WithdrawDataQueryParams {
  chainId: number
  savingsToken: Token
}

export function savingsV2WithdrawDataQueryKey({ chainId, savingsToken }: SavingsV2WithdrawDataQueryParams): QueryKey {
  return ['savings-v2-withdraw-data-query', chainId, savingsToken.symbol]
}

export interface SavingsV2WithdrawDataQueryFunctionParams {
  wagmiConfig: Config
  savingsToken: Token
  underlyingToken: Token
  chainId: number
}
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export async function savingsV2WithdrawDataQueryFunction({
  wagmiConfig,
  savingsToken,
  underlyingToken,
  chainId,
}: SavingsV2WithdrawDataQueryFunctionParams) {
  const liquidity = await readContract(wagmiConfig, {
    address: underlyingToken.address,
    abi: erc20Abi,
    functionName: 'balanceOf',
    args: [savingsToken.address],
    chainId,
  })

  return {
    liquidity: BaseNumber(liquidity).toNormalizedUnit(underlyingToken.decimals),
  }
}
